module.exports = ".tamanho500 {\r\n    width: 500px !important;\r\n}\r\nimg.d-block.w-100{\r\n    height: 375px;\r\n    width: 601px !important;\r\n}"